import { render, staticRenderFns } from "./MapCrudComponent.vue?vue&type=template&id=2f728ae0&scoped=true&"
import script from "./MapCrudComponent.vue?vue&type=script&lang=js&"
export * from "./MapCrudComponent.vue?vue&type=script&lang=js&"
import style0 from "./MapCrudComponent.vue?vue&type=style&index=0&id=2f728ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f728ae0",
  null
  
)

export default component.exports